var app = angular.module("leonardo");

var WorkFlowInstanceDeleteController = function($scope, $rootScope, ngDialog, FilterService) {

  $scope.showDeleteDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/delete-workflow.html',
      controller: 'DeleteWorkflowDialog',
      data: {
        filters: {
          account: FilterService.getFilter('account_reports'),
          managed_by: FilterService.getFilter('managed_by_reports'),
          portfolio: FilterService.getFilter('portfolio_reports'),
          property: FilterService.getFilter('property_reports'),
          status: FilterService.getFilter('workflow_status'),
          search: FilterService.getFilter('search'),
          unit: FilterService.getFilter('unit'),
          workflow: FilterService.getFilter('workflow'),
          started_from_date: FilterService.getFilter('started_from_date'),
          started_to_date: FilterService.getFilter('started_to_date')
        }
      }
    }).then(function() {
      $rootScope.$broadcast('filter-selection:updated');
    });
  };

  $scope.showStopDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/stop-instances.html',
      controller: 'StopInstancesDialog',
      data: {
        filters: {
          account: FilterService.getFilter('account_reports'),
          managed_by: FilterService.getFilter('managed_by_reports'),
          portfolio: FilterService.getFilter('portfolio_reports'),
          property: FilterService.getFilter('property_reports'),
          status: FilterService.getFilter('workflow_status'),
          search: FilterService.getFilter('search'),
          unit: FilterService.getFilter('unit'),
          workflow: FilterService.getFilter('workflow'),
          started_from_date: FilterService.getFilter('started_from_date'),
          started_to_date: FilterService.getFilter('started_to_date')
        }
      }
    }).then(function() {
      $rootScope.$broadcast('filter-selection:updated');
    });
  };
};

app.controller('WorkFlowInstanceDeleteController', ['$scope', '$rootScope', 'ngDialog', 'FilterService', WorkFlowInstanceDeleteController]);
